import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@/app/core/services/auth.service';
import { inject } from '@angular/core';

/**
 * Platform-admin guard (RTA-01).
 *
 * Allows only AgentsBooster platform admins (is_platform_admin === true). This
 * is UX gating only — the real authorization is enforced server-side by
 * ``get_platform_admin_session`` on every /platform/* endpoint.
 */
export const platformAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.getUser()?.is_platform_admin === true) return true;

  router.navigate(['/panel']);
  return false;
};
